// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"vz_a bhn_b bhn_we"};